import { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { getDeviceType } from '@domain-group/fe-brary';
import { handleError, initMixpanel } from '@domain-group/fe-helper';
import getEntryPoint from './get-entry-point';
import { clearListingsSearchUtmSourceSuperProperty } from './utils';
import { flushPendingMixpanelEvents } from './mixpanel';
import { getLocationPermission } from '../utils';

const useMixpanel = ({
  mixpanelToken,
  userId,
  sessionId,
}: {
  mixpanelToken: string;
  userId?: string;
  sessionId?: string;
}): boolean => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!mixpanelToken) {
      return undefined;
    }

    initMixpanel(mixpanel, mixpanelToken, {
      userId,
      sessionToken: sessionId,
    });
    // TODO: clean up when utm source is cleansed
    clearListingsSearchUtmSourceSuperProperty(mixpanel);

    mixpanel.register({
      siteSection: 'Agents',
      deviceCategory: getDeviceType(window?.screen?.width),
      entryPoint: getEntryPoint(),
      locationPermission: false,
    });
    setIsInitialized(true);
    flushPendingMixpanelEvents();

    let isCurrent = true;

    // Snapshot taken once per page load. Nothing on these pages requests the
    // user's location, so it cannot change while they are here. If a feature
    // ever prompts for it, re-register on PermissionStatus change.
    getLocationPermission()
      .then((locationPermission = false) => {
        if (!isCurrent) {
          return;
        }

        mixpanel.register({ locationPermission });
      })
      .catch(handleError);

    return () => {
      isCurrent = false;
      mixpanel.unregister('entryPoint');
      mixpanel.unregister('locationPermission');
    };
  }, [mixpanelToken, sessionId, userId]);

  return isInitialized;
};

export default useMixpanel;
